import React from 'react';
import NCBTester from '../components/debug/NCBTester';
import ErrorBoundary from '../components/ErrorBoundary';

export default function NCBTesterPage() {
  return (
    <ErrorBoundary>
      <NCBTester />
    </ErrorBoundary>
  );
}